/* eslint-disable @typescript-eslint/no-explicit-any */

import { ReactNode } from 'react';

export interface ReportTableColumn<T = any> {
  title?: ReactNode;
  align?: 'left' | 'center' | 'right';
  key?: keyof T;
  ellipsis?: boolean;
  width?: number | string;
  render?: (data: T, index: number) => React.ReactNode | undefined;
  style?: React.CSSProperties;
}

interface Props<T> {
  columns?: ReportTableColumn<T>[];
  dataSource?: T[];
  footer?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

function ReportTable<T extends Record<string, any>>(props: Props<T>) {
  return (
    <table
      className={`report-table ${props.className || ''}`}
      style={props.style}
    >
      <thead>
        <tr>
          {props.columns?.map((column, i) => (
            <th
              key={i}
              style={{
                ...column.style,
                width: column.width,
                maxWidth: column.width,
                textAlign: column.align,
              }}
            >
              {column.title}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {props.dataSource?.map((item, i) => (
          <tr key={i}>
            {props.columns?.map((column, ci) => (
              <td
                key={ci}
                className={column.ellipsis ? 'ellipsis' : ''}
                style={{
                  ...column.style,
                  width: column.width,
                  maxWidth: column.width,
                  textAlign: column.align,
                }}
              >
                {column.render ? column.render(item, i) : null}
                {!column.render && column.key ? item[column.key] : null}
              </td>
            ))}
          </tr>
        ))}
      </tbody>

      {!!props.footer && <tfoot>{props.footer}</tfoot>}
    </table>
  );
}

export default ReportTable;
